export enum ApiKeyFormApiErrorTypes {
  ServiceUnavailableError,
  NotFoundError,
}

export class ApiKeyFormApiError {
  constructor(public type: ApiKeyFormApiErrorTypes, public error: Error) {}
}
